import { default as nodeFetch } from 'node-fetch'
import fetchRetry from 'fetch-retry'

const fetch = fetchRetry( nodeFetch )

export {
  fetch
}
